// CountdownContext.js
import React, {createContext, useContext, useEffect, useState} from 'react';

const CountdownContext = createContext();
let time_count = 90; // 90 = 1 minute 30 seconds

export const useCountdownContext = () => {
    return useContext(CountdownContext);
};

export const CountdownProvider = ({children}) => {
    const [tempState, setTempState] = useState(null);
    const [showCountdown, setShowCountdown] = useState(false);
    const [expiry_at, setExpiryAt] = useState("");
    const [timeLeft, setTimeLeft] = useState(time_count);

    useEffect(() => {

    }, [showCountdown, tempState]);

    const ClearStateCountDown = async () => {
        await setExpiryAt("");
        // await setNotifyCaseID(null);
        await setTempState(null);
        await setShowCountdown(() => false);
        await setTimeLeft(() => time_count);
    }


    return (
        <CountdownContext.Provider value={{
            tempState,
            setTempState,
            showCountdown,
            setShowCountdown,
            setExpiryAt,
            expiry_at,
            ClearStateCountDown,
            time_count,
            timeLeft,
            setTimeLeft
        }}>
            {children}
        </CountdownContext.Provider>
    );
};
